module.exports = __webpack_public_path__ + "static/habitat-hills-logo-7acb1aa7e1a71ffcce13b9e6053f684b.png";